const {
  RANK_7,
  RANK_8,
  RANK_9,
  RANK_J,
  RANK_Q,
  RANK_K,
  RANK_10,
  RANK_A,
} = require("../../shared/game/belot/armenian/types");

const MOLDOVAN_BID_MIN = 80;
const MOLDOVAN_BID_MAX = 250;
const MOLDOVAN_BID_STEP = 10;
const MOLDOVAN_MATCH_TARGETS = Object.freeze([501, 1001]);
const MOLDOVAN_DEFAULT_MATCH_TARGET = 501;
const MOLDOVAN_LAST_TRICK_BONUS = 10;
const MOLDOVAN_CAPOT_POINTS = 250;
const MOLDOVAN_TOTALS = Object.freeze({
  trump: 162,
  allTrumps: 258,
  noTrumps: 140,
});

const MOLDOVAN_DECLARATION_POINTS = Object.freeze({
  terc: 20,
  cinquante: 50,
  cent: 100,
  careuJacks: 200,
  careuNines: 150,
  careuFaces: 100,
  bella: 20,
});

const TRUMP_POINTS_BY_RANK = Object.freeze({
  [RANK_7]: 0,
  [RANK_8]: 0,
  [RANK_9]: 14,
  [RANK_J]: 20,
  [RANK_Q]: 3,
  [RANK_K]: 4,
  [RANK_10]: 10,
  [RANK_A]: 11,
});

const PLAIN_POINTS_BY_RANK = Object.freeze({
  [RANK_7]: 0,
  [RANK_8]: 0,
  [RANK_9]: 0,
  [RANK_J]: 2,
  [RANK_Q]: 3,
  [RANK_K]: 4,
  [RANK_10]: 10,
  [RANK_A]: 11,
});

const MOLDOVAN_GAME_MODES = Object.freeze({
  trump: "trump",
  allTrumps: "all-trumps",
  noTrumps: "no-trumps",
});

module.exports = {
  MOLDOVAN_BID_MIN,
  MOLDOVAN_BID_MAX,
  MOLDOVAN_BID_STEP,
  MOLDOVAN_MATCH_TARGETS,
  MOLDOVAN_DEFAULT_MATCH_TARGET,
  MOLDOVAN_LAST_TRICK_BONUS,
  MOLDOVAN_CAPOT_POINTS,
  MOLDOVAN_TOTALS,
  MOLDOVAN_DECLARATION_POINTS,
  TRUMP_POINTS_BY_RANK,
  PLAIN_POINTS_BY_RANK,
  MOLDOVAN_GAME_MODES,
};
